<script lang="ts">
  import { createEventDispatcher, onDestroy, onMount } from 'svelte'
  import { getDeliveryOptions } from '../../persistence'
  import { db } from '../../db'
  import { syncCount } from '../../stores'

  const dispatch = createEventDispatcher()
  const controller = new AbortController()

  const fetchDeliveryOptions = async () => {
    const { deliveryOptions = [], error } = await getDeliveryOptions({ internal: true }, true, controller)

    if (error || controller.signal.aborted) return false

    await db.deliveryOptions.bulkPut(deliveryOptions)

    return !controller.signal.aborted
  }

  onDestroy(() => controller.abort())

  onMount(async () => {
    try {
      syncCount.update(count => count + 1)
      if (await fetchDeliveryOptions()) dispatch('success')
    } finally {
      syncCount.update(count => count - 1)
    }
  })
</script>
